import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ContractManagementService } from '../contract-management.service';
import * as ChargeNumberManagementActions from './charge-number-management.actions';
import { catchError, switchMap, map, flatMap } from 'rxjs/operators';
import * as fromShared from '../../shared';
import {
    DisplayMessageMinimum,
    IStatusMessage,
    ResponseStatus
} from '../../shared';

@Injectable()
export class ChargeNumberManagementEffects {
    constructor(
        private actions$: Actions,
        private service: ContractManagementService
    ) {}

    getChargeNumbers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ChargeNumberManagementActions.getChargeNumbers),
            switchMap(x =>
                this.service.getChargeNumbers(x.Contract).pipe(
                    flatMap(resp => [
                        ChargeNumberManagementActions.loadChargeNumberManagements(
                            {
                                chargeNumberManagements: resp
                            }
                        ),
                        // new fromShared.Errors.RemoveErrors(
                        //     resp
                        //         .filter(
                        //             cnm =>
                        //                 cnm.Status.StatusCode ===
                        //                 ResponseStatus.Success
                        //         )
                        //         .map(cnm => cnm.CNListID)
                        // ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        a =>
                                            a.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putChargeNumbers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ChargeNumberManagementActions.putChargeNumbers),
            switchMap(a =>
                this.service.putCNMgmt(a.chargeNumbers).pipe(
                    flatMap(c => [
                        ChargeNumberManagementActions.updateChargeNumberManagements(
                            {
                                chargeNumberManagements: [
                                    {
                                        id: a.chargeNumbers
                                            .map(x => x.CNListID)
                                            .toString(),
                                        changes: c.Items[0]
                                    }
                                ]
                            }
                        ),
                        new fromShared.Errors.RemoveErrors(
                            c.Items.filter(
                                x =>
                                    x.Status.StatusCode ===
                                    ResponseStatus.Success
                            ).map(x => x.CNListID.toString())
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...c.ErrorMessages.map(
                                    x =>
                                        ({
                                            StatusCode: -1,
                                            Message: x,
                                            MsgProcessID: 0,
                                            MsgEntityID: ''
                                        } as IStatusMessage)
                                ),
                                ...c.Items.filter(
                                    x =>
                                        x &&
                                        x.Status.StatusCode >=
                                            DisplayMessageMinimum
                                ).map(x => x.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
